import styled from 'styled-components';
import { FIELDSET_VERTICAL_SPACING, SPACES } from '@belong/themes';

export const InlineContainer = styled.div`
  display: flex;
  gap: ${SPACES.small}rem ${SPACES.medium}rem;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const InputContainer = styled.div`
  flex: 1 1 28ch;
  margin-top: 0;

  > * {
    margin-top: ${FIELDSET_VERTICAL_SPACING};
  }
`;
